import ElasticsearchAPI from '../../ElasticsearchAPI'

async function broadcastDates (dataset = '') {
  const esSearch = {
    'size': 0,
    'aggs': {
      'months': {
        'terms': {
          'field': 'broadcastdate',
          'format': 'yyyy-MM',
          'size': 50,
          'order': {'_key': 'asc'}
        },
        'aggs': {
          'start_date': {
            'max': {
              'field': 'broadcastmonthstartdate',
              'format': 'yyyy-MM-dd'
            }
          },
          'end_date': {
            'max': {
              'field': 'broadcastmonthenddate',
              'format': 'yyyy-MM-dd'
            }
          }
        }
      },
      'mri': {
        'filter': {
          'exists': {
            'field': 'mri.mri_yes'
          }
        },
        'aggs': {
          'latest_month': {
            'max': {
              'field': 'broadcastdate',
              'format': 'yyyy-MM'
            }
          }
        }
      },
      'ncs': {
        'filter': {
          'exists': {
            'field': 'ncs.ncs_yes'
          }
        },
        'aggs': {
          'latest_month': {
            'max': {
              'field': 'broadcastdate',
              'format': 'yyyy-MM'
            }
          }
        }
      }
    }
  }
  if (dataset && dataset !== 'amrld') esSearch.query = {'bool': {'must': {'exists': {'field': `${dataset}.${dataset}_yes`}}}}
  
  try {
    const response = await ElasticsearchAPI.broadcastDates(esSearch)
    const results = response
    const months = results.aggregations.months.buckets
    results.aggregations.months.buckets = months.slice(-24)
    return {data: results}
  } catch (error) {
    console.error('Error fetching broadcast dates:', error)
    return {data: null}
  }
}

export default broadcastDates



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/broadcastDates.js